<ng-select dropdownPosition="bottom" [items]="options()" [multiple]="true" bindLabel="key" bindValue="value"
  groupBy="group" [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="false" [ngModel]="value()"
  (ngModelChange)="handleValueChange($event)" [placeholder]="placeholder()" [searchable]="searchable()" [disabled]="disabled()"
  class="dropdown-select">
  <ng-template ng-header-tmp>
    <div class="ng-dropdown-header">
      <!-- According to design, the search input should actually go here,-->
      <!-- but ng-select does not support that (moving the filter input to header). -->
      @if (includeShowAll()) {
      <div class="show-all" [class.disabled]="!displayShowAll()">
        <label (click)="clickShowAll()">{{ 'MULTI_SELECT.SHOW_ALL' | translate }}</label>
      </div>
      }
    </div>
  </ng-template>
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    @if (items.length === maxTagCount()) {
    @for (item of items; track item.key) {
    <div class="ng-value">
      <span class="ng-value-label"> {{ item.key }}</span>
      <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"></span>
    </div>
    }
    }
    @if (items.length > maxTagCount()) {
    <div class="ng-value">
      <span class="ng-value-label">
        @if (items.length === options().length) {
        {{ 'MULTI_SELECT.ALL_SELECTED' | translate }}
        }
        @else if (items.length > options().length/2) {
        {{ 'MULTI_SELECT.EXCLUDED_ITEMS' | translate : { count: options().length - items.length } }}
        }
        @else {
        {{ 'MULTI_SELECT.SELECTED_ITEMS' | translate : { count: items.length } }}
        }
      </span>
      <span class="ng-value-icon right" (click)="clearAllOptions()" aria-hidden="true"></span>
    </div>
    }
  </ng-template>
  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.group | translate }}
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
    <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" /> {{ item.key }}
  </ng-template>
</ng-select>
